import CodeForm, { HandleEmployeeSign } from 'components/form/CodeForm';
import { IModalProps } from 'store/modal';

type Options = {
  docId: string;
  showModal: (props: IModalProps) => void;
  heading: string;
  handleEmployeeSign: HandleEmployeeSign;
  extraAction?: boolean;
  extraActionCB?: () => void;
  setExitInterviewRef?: (toggle: boolean) => void;
};

const handleEmployeeCode = ({
  docId,
  showModal,
  heading,
  handleEmployeeSign,
  extraAction,
  extraActionCB,
  setExitInterviewRef,
}: Options): void => {
  showModal({
    type: 'form',
    heading,
    content: (
      <CodeForm
        handleEmployeeSign={handleEmployeeSign}
        docId={docId}
        extraAction={extraAction}
        extraActionCB={extraActionCB}
        setExitInterviewRef={setExitInterviewRef}
      />
    ),
  });
};

export default handleEmployeeCode;
